import { ID_QUERY, CommonRes } from './common';
import { startCase } from '../helperUtils';

export interface TagResItem extends CommonRes {
  name: string;
  description: string;
  metaTitle: string;
  metaDescription: string;
  slug: string;
}

export class Tag {
  id: string;
  name: string;
  slug: string;
  description: string;
  title: string;

  constructor(item: TagResItem) {
    this.id = item.sys.id;
    this.name = item.name;
    this.slug = item.slug;
    this.description = item.description;
    this.title = startCase(item.name);
  }
  static getQuery = ({ slug }: { slug?: string }) => {
    const slugFilter = slug ? `slug: "${slug}",` : '';
    return `
      query {
        tagCollection(
          limit: 1000,
          where: {
            ${slugFilter}
          }
        ){
          items{
            ${ID_QUERY}
            name
            description
            metaDescription
            metaTitle
            slug
          }
        }
      }
    `;
  };
}
